import React from 'react'
import { useHistory } from 'react-router-dom'
import { ExternalLink as ExternalLinkIcon } from 'react-feather'
import { Box, makeStyles, Button } from '@material-ui/core'

import helpers from 'helpers'

import styles from './styles'
import { routes } from 'Routes'

const useStyles = makeStyles(styles)

const HelpCentralBox = () => {
  const history = useHistory()
  const classes = useStyles()

  const { mixpanel } = helpers

  const mixpanelTrack = () => {
    mixpanel.track('Fornecedores', 'Novo fornecedor', {
      action: 'cliente utilizou os botões de ajuda',
    })
  }

  const handleRedirect = () => {
    if (window.document.title === 'Novo fornecedor') mixpanelTrack()

    history.push(routes.helpCenter.all)
  }

  return (
    <Box p={2} className={classes.root}>
      <Button
        className={classes.helpCentralButton}
        variant="contained"
        endIcon={
          <ExternalLinkIcon
            className={classes.helpCentralButtonIcon}
            size="16"
          />
        }
        onClick={handleRedirect}
        size="small"
      >
        Central de atendimento
      </Button>
    </Box>
  )
}

export default HelpCentralBox
